module.exports = __webpack_public_path__ + "static/media/iPhoneDark.9f76decd.png";